import React from 'react';
import { connect } from 'react-redux';
import { Menu } from 'semantic-ui-react';
import { truncateText } from '@/utils/resultsHelper';
import CustomDatasetActionImage from '../components/CustomDatasetActionImage';

const CustomDatasetAction = ({
  url,
  label,
  description,
  target,
  disabled,
  fullscreen,
  hasLabels,
}) => (
  <Menu.Item
    name={label}
    title={description}
    href={disabled ? null : url}
    target={target}
    disabled={disabled}
    className="aridhia-ribbon-menu aridhia-custom-dataset-action"
    rel="noopener noreferrer"
  >
    {!fullscreen && (<CustomDatasetActionImage description={description} label={label} />)}
    {hasLabels && (<span>{truncateText(label)}</span>)}
  </Menu.Item>
);

const mapStateToProps = ({
  layout: {
    labels, fullscreen,
  },
}) => ({
  fullscreen,
  hasLabels: labels || fullscreen,
});

export default connect(mapStateToProps)(CustomDatasetAction);
